
import { NavLink } from "react-router-dom";
import { useEffect, useState, useContext,  useMemo} from 'react'; // useMemo pour Table.jsx
import { apiGetProprietesFree, apiSoumissionFormulaireDemande } from '../Datas/datasAutre.js'

/**
 * Return Page CreationCompte POUR TEST
 *
 * @component
 * @summary CreationCompte
 * @param {  }
 * @return { HTMLElement }
*/

const CreationCompte = () => {
  const [organismes, setOrganismes] = useState([]);
  const [showAjout, setShowAjout] = useState(false);
  const [nouvelOrganisme, setNouvelOrganisme] = useState({ Nom: '', Adresse: '', Telephone: '' });

  const ouvrirFormulaire = () => {
    setNouvelOrganisme({ Nom: '', Adresse: '', Telephone: '' });
    setShowAjout(true);
  };

  const fermerFormulaire = () => {
    setShowAjout(false);
  };

  const validerAjout = () => {
    if (!nouvelOrganisme.Nom.trim()) {
      alert('Le nom est obligatoire.');
      return;
    }
    setOrganismes([...organismes, nouvelOrganisme]);
    setShowAjout(false);
  };

  const supprimerOrganisme = (index) => {
    const copie = [...organismes];
    copie.splice(index, 1);
    setOrganismes(copie);
  };

  const enregistrer = async () => {
    try {
      
      /*  const response = await fetch('/api/organismes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(organismes),
      });

      if (response.ok) {
        alert('Organismes enregistrés avec succès.');
        setOrganismes([]);
      } else {
        alert('Erreur serveur lors de l’enregistrement.');
      }*/
           var dataR = await apiSoumissionFormulaireDemande("", organismes, "creation-compte");
           if(global.config.modeDebugApp == 1) console.log('retour apiSoumissionFormulaireDemande : ', dataR);
     
           switch (dataR.statusCode) {
               case 200: 
                    alert("Votre demande a bien été transmise, nous vérifions l'ensemble des éléments communiqués et revenons vers vous dans les plus brefs délais.");
                   break;
               case 401:
                   setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
                   break;
               default:
                   setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
           }
    } catch (err) {
      console.error(err);
      alert('Erreur réseau.');
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '700px', margin: '0 auto' }}>
      <h2>Liste des organismes</h2>

      {organismes.length === 0 && <p>Aucun organisme ajouté.</p>}

      {organismes.map((org, index) => (
        <div
          key={index}
          style={{
            border: '1px solid #ccc',
            padding: '15px',
            marginBottom: '10px',
            borderRadius: '5px',
          }}
        >
          <strong>{org.Nom}</strong><br />
          {org.Adresse}<br />
          {org.Telephone}<br />
          <button
            onClick={() => supprimerOrganisme(index)}
            style={{ marginTop: 10, background: 'red', color: 'white' }}
          >
            Supprimer
          </button>
        </div>
      ))}

      {!showAjout && (
        <>
          <button onClick={ouvrirFormulaire} style={{ marginRight: 10 }}>
            ➕ Ajouter un organisme
          </button>

          {organismes.length > 0 && (
            <button onClick={enregistrer} style={{ background: 'green', color: 'white' }}>
              💾 Enregistrer tous
            </button>
          )}
        </>
      )}

      {showAjout && (
        <div
          style={{
            marginTop: 30,
            border: '2px solid #007bff',
            padding: '20px',
            borderRadius: '5px',
            background: '#f9f9f9',
          }}
        >
          <h3>Nouvel organisme</h3>
          <div>
            <label>Nom :</label>
            <input
              type="text"
              value={nouvelOrganisme.Nom}
              onChange={(e) => setNouvelOrganisme({ ...nouvelOrganisme, Nom: e.target.value })}
              style={{ marginLeft: 10 }}
            />
          </div>
          <div>
            <label>Adresse :</label>
            <input
              type="text"
              value={nouvelOrganisme.Adresse}
              onChange={(e) => setNouvelOrganisme({ ...nouvelOrganisme, Adresse: e.target.value })}
              style={{ marginLeft: 10 }}
            />
          </div>
          <div>
            <label>Téléphone :</label>
            <input
              type="text"
              value={nouvelOrganisme.Telephone}
              onChange={(e) => setNouvelOrganisme({ ...nouvelOrganisme, Telephone: e.target.value })}
              style={{ marginLeft: 10 }}
            />
          </div>

          <div style={{ marginTop: 15 }}>
            <button onClick={validerAjout} style={{ marginRight: 10, background: 'blue', color: 'white' }}>
              ✅ Ajouter
            </button>
            <button onClick={fermerFormulaire}>❌ Annuler</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreationCompte;